import { render, staticRenderFns } from "./ViewTransactionPage.vue?vue&type=template&id=0be1ccda&scoped=true&"
import script from "./ViewTransactionPage.vue?vue&type=script&lang=js&"
export * from "./ViewTransactionPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewTransactionPage.vue?vue&type=style&index=0&id=0be1ccda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be1ccda",
  null
  
)

export default component.exports